exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_paper__1M1Nb{margin-top:1.5rem}", ""]);

// exports
exports.locals = {
	"paper": "style_paper__1M1Nb"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/areas/dashboard/DashboardConfiguration/style.less
// module id = 1758
// module chunks = 8